<app-template-grid [disabled]="disabled" [value]="value" [control]="control" [date]="date" [text]="text" [label]="label" />
